const module = { name: 'movie/shared/mop.onDemandUI', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { fd_url_manager as links } from 'require-core';



import { swig as swig } from 'require-core';



import { global_consts as global_consts_MOPViewTypes } from 'require-core';

const { MOPViewTypes } = global_consts_MOPViewTypes;


import { Fandango as Fandango_context } from 'require-core';

const { context } = Fandango_context;


import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from 'require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


const Selectors = {
    HOW_TO_WATCH_MODULE: '#watch-at-home-module',
    ON_DEMAND_DETAILS: '#on-demand-details',
    ON_DEMAND_STREAMING_WATCH_AT_HOME: '#on-demand-streaming-watch-on-demand',
    NO_SHOWTIMES_CONTAINER: '#no-showtimes-container',
    MOVIE_SECTION: '#now-playing-section'
}


const Styles = {
    DESKTOP_PANEL: 'movie-detail',
    HIDE: 'hide',
    BORDERLESS_PANEL: 'fd-panel--no-border',
    PANEL: 'fd-panel',
}
function attachEventHandlers({ isPreOrder }) {
    $(Selectors.ON_DEMAND_STREAMING_WATCH_AT_HOME).on('click', () => track({
        clickDetails: `movie | overview | ${isPreOrder ? 'preorder' : 'watch at home'} price click`,
        event: EventTypes.GENERIC_CLICK,
    }));
}
function getStreamingLink({ isPreOrder, isPreOrderOnly, isTicketingWindow, showStreaming, streamingServices, }) {
    const service = streamingServices.vudu;
    let param = '';
    if (showStreaming && isTicketingWindow && !isPreOrder) {
        param = 'MOP_watchathome_tab';
    }
    if (showStreaming && !isTicketingWindow && !isPreOrder) {
        param = 'MOP_watchathome_tab__athomeonly';
    }
    if (isPreOrderOnly) {
        param = 'MOP_watchathome_preorder__preorderonly';
    }
    if (isPreOrder && !isPreOrderOnly) {
        param = 'MOP_watchathome_preorder';
    }
    return `${service}${param && '?cmp=' + param}`;
}
function done(opts) {
    return;
    const { lowestStreamingPrice, poster, releaseDate, showStreaming, showStreamingPresale, streamingServices, title, trackingAttribs, trackingState, isDesktop, isTicketingWindow, vuduMovieId } = opts || {};
    if (!showStreaming && !showStreamingPresale) {
        return;
    }
    const isPreOrder = showStreamingPresale && !showStreaming;
    const isPreOrderOnly = isPreOrder && !isTicketingWindow;
    const streamingLink = getStreamingLink({
        isPreOrder,
        isPreOrderOnly,
        isTicketingWindow,
        showStreaming,
        streamingServices,
    });
    const markup = swig.render('_onDemandStreaming', {
        isDesktop,
        isPreOrder,
        lowestStreamingPrice,
        moreLink: links.vudu(),
        poster: vuduMovieId ? links.vuduPosterUrl({ vuduMovieId }) : (poster && poster.size['200'] || ''),
        streamingLink,
        title,
    });
    const $onDemandDetails = $(Selectors.ON_DEMAND_DETAILS).html(markup);
    if (isDesktop) {
        $onDemandDetails.addClass(Styles.BORDERLESS_PANEL);
    }
    $(Selectors.MOVIE_SECTION).addClass(Styles.BORDERLESS_PANEL);
    attachEventHandlers({ isPreOrder });
    track({
        event: EventTypes.MOP_PAGE_STATE,
        releaseDate,
        movieState: trackingState,
        movieAttributes: trackingAttribs
    });
}
module.exports = {
    done
};
export default module.exports;